import BulbSVG from "../../../public/icons/benefits/bulb.svg";
import CpuSVG from "../../../public/icons/benefits/cpu.svg";
import PresentSVG from "../../../public/icons/benefits/present.svg";
import RocketSVG from "../../../public/icons/benefits/rocket.svg";
import StarsSVG from "../../../public/icons/benefits/stars.svg";
import TShirtSVG from "../../../public/icons/benefits/tshirt.svg";
import BandIMG from "../../../public/images/history/band.jpg";
import BedIMG from "../../../public/images/history/bed.jpg";
import BreakfastIMG from "../../../public/images/history/breakfast.jpg";
import DogIMG from "../../../public/images/history/dog.jpg";
import KindergardenIMG from "../../../public/images/history/kindergarden.jpg";
import OfficeBackofficeIMG from "../../../public/images/history/office-backoffice.jpg";
import OfficeEmptyIMG from "../../../public/images/history/office-empty.jpg";
import OfficeMeetingRoomIMG from "../../../public/images/history/office-meeting-room.jpg";
import OfficePresentationIMG from "../../../public/images/history/office-presentation.jpg";
import VrIMG from "../../../public/images/history/vr.jpg";
import PresentationIMG from "../../../public/images/history/presentation.jpg";
import WhiteboardIMG from "../../../public/images/history/whiteboard.jpg";
import WinterTripIMG from "../../../public/images/history/winter-trip.jpg";
import DogCodingIMG from "../../../public/images/history/dog-coding.jpg";
import AiHackaton from "../../../public/images/history/ai-hackaton.jpg"
import Image from "next/image";
import { Milestone } from "../types";

export const translatedMilestones = (t: any): Milestone[] => {
  const milestones = [
    { value: 2015 },
    {
      value: t("milestones.first"),
      icon: <BulbSVG />,
    },
    {
      value: (
        <Image src={DogCodingIMG} alt={t("milestones.image-alt.coding-dog")} />
      ),
    },
    {
      value: (
        <Image src={WhiteboardIMG} alt={t("milestones.image-alt.whiteboard")} />
      ),
    },
    { value: 2017 },
    {
      value: t("milestones.second"),
      icon: <PresentSVG />,
    },
    {
      value: (
        <Image
          src={OfficeMeetingRoomIMG}
          alt={t("milestones.image-alt.meeting-room")}
        />
      ),
    },
    {
      value: <Image src={DogIMG} alt={t("milestones.image-alt.working-dog")} />,
    },
    { value: 2019 },
    {
      value: t("milestones.third"),
      icon: <RocketSVG />,
    },
    {
      value: <Image src={BedIMG} alt={t("milestones.image-alt.bed")} />,
    },
    {
      value: (
        <Image src={BreakfastIMG} alt={t("milestones.image-alt.breakfast")} />
      ),
    },
    {
      value: <Image src={BandIMG} alt={t("milestones.image-alt.band")} />,
    },
    { value: 2021 },
    {
      value: t("milestones.fourth"),
      icon: <CpuSVG />,
    },
    {
      value: (
        <Image
          src={OfficeBackofficeIMG}
          alt={t("milestones.image-alt.chatting")}
        />
      ),
    },
    {
      value: (
        <Image src={KindergardenIMG} alt={t("milestones.image-alt.working")} />
      ),
    },
    {
      value: (
        <Image src={WinterTripIMG} alt={t("milestones.image-alt.winter")} />
      ),
    },
    { value: 2022 },
    {
      value: "",
      illustration: true,
    },
    {
      value: t("milestones.fifth"),
      icon: <StarsSVG />,
    },
    {
      value: (
        <Image
          src={OfficeEmptyIMG}
          alt={t("milestones.image-alt.empty-office")}
        />
      ),
    },
    { value: 2023 },
    {
      value: t("milestones.sixth"),
      icon: <TShirtSVG />,
    },
    {
      value: (
        <Image
          src={OfficePresentationIMG}
          alt={t("milestones.image-alt.presenting")}
        />
      ),
    },
    {
      value: (
        <Image
          src={PresentationIMG}
          alt={t("milestones.image-alt.representing")}
        />
      ),
    },
    {
      value: <Image src={VrIMG} alt={t("milestones.image-alt.vr")} />,
    },
    {
      value: t("milestones.seventh"),
      icon: <BulbSVG />,
    },
    {
      value: (
        <Image
          src={AiHackaton}
          alt={t("milestones.image-alt.hackaton")}
        />
      ),
    },
    { value: 2024 },
    {
      value: t("milestones.eighth"),
      icon: <RocketSVG />,
    },
    {
      value: t("milestones.ninth"),
      icon: <PresentSVG />,
    },
    {
      value: t("milestones.tenth"),
      icon: <CpuSVG />,
    },
  ];

  return milestones;
};
